<template>
    <div class="table-responsive">
        <!-- {{ tableData }} -->
        <table class="table table-bordered table-sm table-hover mb-0">
            <thead class="thead-light">
                <tr>
                    <th class="text-center align-middle ">결측 상태</th>
                    <th class="text-center align-middle ">결측 시작</th>
                    <th class="text-center align-middle ">결측 종료</th>
                    <th class="text-center align-middle ">지속 시간</th>
                    <th class="text-center align-middle ">결측 총량</th>
                    <th class="text-center align-middle ">누락 데이터 수</th>
                </tr>
            </thead>
            <tbody>
                <template v-if="formattedData.length > 0">
                    <tr v-for="event in formattedData" :key="event.eventIdx">
                        <td class="text-center align-middle ">{{ event.status ?? "-" }}</td>
                        <td class="text-center align-middle ">{{ event.start ?? "-" }}</td>
                        <td class="text-center align-middle ">{{ event.end ?? "-" }}</td>
                        <td class="text-center align-middle ">{{ event.duration ?? "-" }}</td>
                        <td class="text-center align-middle ">{{ event.missingAmt ?? "-" }}</td>
                        <td class="text-center align-middle ">{{ event.missingCnt ?? "-" }}</td>
                    </tr>
                </template>
                <tr v-else class="text-center">
                    <td colspan="6" class="empty-state-cell">
                        <div class="empty-state-content">
                            <div class="empty-state-icon">
                                <i class="fa fa-check-circle"></i>
                            </div>
                            <div class="empty-state-text">
                                <h6 class="empty-state-title">{{ $t("데이터 결측이 발생하지 않았습니다.") }}</h6>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import moment from "moment";
import "moment/locale/ko";
import excelHelper from "@src/libs/excelHelper.js";

moment.locale("ko");

export default {
    props: {
        tableData: {
            type: Array,
            default: () => [],
        },
        flagMissingDownload: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        flagMissingDownload(flag) {
            if (flag) {
                this.exportToExcel();
            }
        },
    },
    computed: {
        formattedData() {
            return this.tableData.map((event) => {
                const start = moment(event.startDt.toString(), "YYYYMMDDHHmmss");
                const end = event.endDt ? moment(event.endDt, "YYYYMMDDHHmmss") : "";
                const duration = end ? moment.duration(end.diff(start)) : "";
                const hours = duration ? Math.floor(duration.asHours()) : "";
                const minutes = duration ? duration.minutes() : "";
                const status = this.$store.state.commonCodes.missingStatus.find((s) => s.value == event.status);
                return {
                    ...event,
                    start: start ? start.format("YYYY년 MM월 DD일 HH:mm:ss") : "-",
                    end: end ? end.format("YYYY년 MM월 DD일 HH:mm:ss") : "-",
                    // duration: moment.duration(end.diff(start)).humanize(),
                    duration: duration
                        ? [hours ? `${hours}시간` : "", minutes ? `${minutes}분` : ""].filter(Boolean).join(" ")
                        : "-",
                    status: status ? status.text : "-",
                    // status: event.status ? event.status : "-",
                    missingAmt: event.missingAmt ? event.missingAmt.toFixed(1) : "-",
                };
            });
        },
    },
    methods: {
        async exportToExcel() {
            try {
                // 헤더 정의
                const headers = ["결측 상태", "결측 시작", "결측 종료", "지속 시간", "결측 총량", "누락 데이터 수"];

                // 데이터 변환 (excelHelper 형식에 맞게)
                const excelData = this.formattedData.map((item) => ({
                    "결측 상태": item.status || "-",
                    "결측 시작": item.start || "-",
                    "결측 종료": item.end || "-",
                    "지속 시간": item.duration || "-",
                    "결측 총량": item.missingAmt || "-",
                    "누락 데이터 수": item.missingCnt || "-",
                }));

                // 파일명 생성 (현재 날짜 포함)
                const currentDate = new Date().toISOString().slice(0, 10);
                const fileName = `결측데이터_${currentDate}.xlsx`;

                // excelHelper를 사용하여 워크북 생성 및 다운로드
                await excelHelper.createAndDownloadWorkbook(excelData, headers, fileName, {
                    sheetName: "결측데이터",
                    creator: "THEKIE",
                    lastModifiedBy: "THEKIE",
                    columnWidths: {
                        "결측 상태": 12,
                        "결측 시작": 20,
                        "결측 종료": 20,
                        "지속 시간": 15,
                        "결측 총량": 15,
                        "누락 데이터 수": 15,
                    },
                    cellTypes: {
                        "결측 상태": "string",
                        "결측 시작": "string",
                        "결측 종료": "string",
                        "지속 시간": "string",
                        "결측 총량": "number",
                        "누락 데이터 수": "number",
                    },
                });

                this.$emit("update:flagMissingDownload", false);
            } catch (error) {
                console.error("엑셀 다운로드 중 오류 발생:", error);
                this.$emit("download-error", error.message);
            }
        },
    },
};
</script>

<style scoped>
.table-responsive {
    height: 70vh;
    overflow-y: auto;
    position: relative;
}
table {
    border-collapse: collapse;
    width: 100%;
    table-layout: fixed;
}

thead {
    position: sticky;
    top: 0;
    background-color: #f8f9fa;
    z-index: 1;
}
.table thead th {
    font-size: 13px;
    font-weight: 600;
}
.table tbody td {
    font-size: 13px;
}

/* Empty State Styling */
.empty-state-cell {
    padding: 60px 20px !important;
    /* background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%); */
    /* border: 2px dashed #28a745; */
}

.empty-state-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
}

.empty-state-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
    transition: all 0.3s ease;
}

.empty-state-icon:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(40, 167, 69, 0.4);
}

.empty-state-icon i {
    font-size: 20px;
    color: white;
}

.empty-state-text {
    text-align: center;
    max-width: 300px;
}

.empty-state-title {
    color: #155724;
    font-weight: 600;
    margin-bottom: 8px;
    font-size: 16px;
}

.empty-state-description {
    color: #155724;
    font-size: 14px;
    margin: 0;
    line-height: 1.5;
}

/* Table hover effect for empty state */
/* .empty-state-cell:hover {
    background: linear-gradient(135deg, #c3e6cb 0%, #b1dfbb 100%);
    border-color: #20c997;
} */
</style>
